/**
 * Created by pandemio on 9/20/18.
 */
import React from 'react';
import {Col, Card, CardBody, CardHeader, Container, Row, Alert} from 'reactstrap';
import {Redirect} from "react-router-dom";
/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/

import ApiCalls from "../../custom-classes/api-calls";
import LanguageManager from '../../custom-classes/language-manager';
import SelectorStudentProduct from "../selectors/selector-student-products";
import SelectorLesson from '../selectors/selector-lesson';
import SelectorExam from '../selectors/selector-exam';
import ChartAverage from '../charts/chart-average';
import ChartLessonTries from '../charts/chart-lesson-tries';
import TableTotalTries from '../tables/table-total-tries';
import RandomRGBA from '../../custom-classes/rgba-random';
import NavbarMobile from '../navbar/navbar-mobile';
import NavbarDesktop from '../navbar/navbar-desktop-top';
import Footer from '../footer/footer';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChartBar} from '@fortawesome/free-solid-svg-icons';

/**
 * Class/component of the student average
 */
class ReportStudentLessonAverage extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        let languages = [
            {name: "English", code: "en"},
            {name: "Español", code: "es"}
        ];

        // To support language library add the following lines
        this.props.initialize({
            languages,
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });
        this.props.addTranslation(global);

        if (this.props.location.state !== undefined) {
            this.state = {
                productId: this.props.location.state.productId,
                studentId: this.props.location.state.studentId,
                lessonId: this.props.location.state.lessonId,
                examId: "0",
                languages: languages, // Repeat language here, because we need it to pass it the child to create inline translation
                passedTotal: "0",
                notPassedTotal: "0",
                triesChartData: null,
                triesData: null,
                studentName: null,
                navbarMobile: false
            };
        }
        else {
            this.state = {
                productId: null,
                studentId: null,
                studentName: null,
                lessonId: null,
                languages: languages, // Repeat language here, because we need it to pass it the child to create inline translation
                passedTotal: "0",
                notPassedTotal: "0",
                examId: "0",
                triesChartData: null,
                triesData: null,
                navbarMobile: false
            };
        }
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    /**
     * Handles the state when the component will be mounted
     */
    componentWillMount() {
        if (this.props.location.state !== undefined) {
            if (this.props.location.state.productId !== undefined)
                this.setState({productId: this.props.location.state.productId});

            if (this.props.location.state.studentId !== undefined)
                this.setState({studentId: this.props.location.state.studentId});

            if (this.props.location.state.lessonId !== undefined)
                this.setState({lessonId: this.props.location.state.lessonId});

            if (this.state.lessonId !== null && this.state.studentId !== null && this.state.productId)
                this.callResults(); // If none of them are null/0 call the results
        }


    }

    /**
     * Call the lessons of the product
     */
    callLessons = () => (newValue) => {
        this.setState({productId: newValue, lessonId: null});
    };

    /**
     * Call the student classes
     */
    callStudentProducts = () => (newValue) => {
        this.setState({
            studentId: newValue,
            productId: null
        });
    };

    /**
     * Call the user details to set everything
     */
    callStudentAnalysis = () => (newValue) => {
        // The exam is reset everytime we call this
        this.setState({lessonId: newValue, examId: "0"}, ()=> {
            this.callResults();
        });

    };

    /**
     * Call the results to display
     */
    callResults() {
        // Call the api of student average
        let apiCall = ApiCalls.getStudentLessonAverage(this.state.studentId.value, this.state.lessonId.value);
        apiCall.then((data)=> {
            this.setState({
                passedTotal: parseFloat(data.LessonAverage),
                notPassedTotal: parseFloat(100 - parseFloat(data.LessonAverage)).toFixed(2)
            });
        });
    }

    /**
     * Call the user tries
     */
    callTries = () => (newValue) => {
        this.setState({examId: newValue}, ()=> {

            // We should fill the chart and the table
            let apiCall = ApiCalls.getQuizzesTries(this.state.examId, this.state.studentId.value);
            apiCall.then((data)=> {

                // Set the data to the table
                this.setState({triesData: data.UserQuizTries});

                // Now, work with the chet
                // Work with the chart
                let labelTry = LanguageManager.getTranslation("report-student-average.try", this.state.languages);
                let labelTries = LanguageManager.getTranslation("report-student-average.tries", this.state.languages);

                // Prepare the data to the lesson
                let labels = [];
                let backgroundColors = [];
                let datasets = [{
                    label: '# ' + labelTries,
                    borderWidth: 1
                }];
                let dataArray = [];
                for (let i = 0; i < data.UserQuizTries.length; i++) {
                    labels.push(labelTry + ' ' + (i + 1).toString());
                    dataArray.push(data.UserQuizTries[i].TotalPercent);
                    backgroundColors.push(RandomRGBA.randomRgba())
                }
                datasets[0].data = dataArray;
                datasets[0].fillColor = backgroundColors;
                datasets[0].borderColor = backgroundColors;

                let dataChartBar = {
                    labels: labels,
                    datasets: datasets
                };

                return dataChartBar;
            }).then((dataChartBar)=> {
                this.setState({triesChartData: dataChartBar});
            });
        });
    };

    /**
     * Render the form details
     * @returns {XML}
     */
    render() {

        if(typeof this.state.studentId === 'undefined'
            || this.state.studentId === null)
            return (<Redirect  to={{
                pathname: "/report-average"
            }}/>);

        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-padding">
                    <Container className={this.state.navbarMobile ? "margin-top-mandatory-60" : null}>
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faChartBar}/>{' '}
                            <Translate id="navbar.student-lesson-average" options={{renderInnerHtml: true}}/>
                        </h2>
                        <hr/>
                    <Row>
                        <Col sm={{size: 12, offset: 0}} lg={{size: 6, offset: 0}} md={{size: 8, offset: 0}}>
                            <Card className="card-blue-transparency">
                                <CardHeader>
                                    <h4 className="white-text">
                                        <Translate id="report-student-average.student-lesson-average"
                                                   options={{renderInnerHtml: false}}/>
                                    </h4>
                                    <small>
                                        <Translate id="report-student-average.student-lesson-average-subtitle"
                                                   options={{renderInnerHtml: false}}/>
                                    </small>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col sm={{size: 12}} md={{size: 6}} lg={{size: 6}}>
                                            <p>
                                                <b><Translate id="report-student-average.student"
                                                             options={{renderInnerHtml: true}}/>
                                                </b>
                                            </p>
                                            <p>
                                                {
                                                    this.state.studentId.GivenName
                                                    + ' ' + this.state.studentId.Surname
                                                    + ' (' + this.state.studentId.Username + ') '}
                                            </p>

                                        </Col>
                                        <Col sm={{size: 12}} md={{size: 6}} lg={{size: 6}}>
                                            <p><b><Translate id="report-student-average.select-class"
                                                             options={{renderInnerHtml: true}}/></b></p>
                                            { this.state.studentId !== null ?
                                                <div className="gray-dark-text">
                                                <SelectorStudentProduct value={this.state.productId} data={this.state}
                                                                        updateParent={this.callLessons()}/>
                                                </div>: null }
                                        </Col>
                                        <Col sm={{size: 12}} lg={{size: 12}}>
                                            <p><b><Translate id="syllabus.select-lesson"
                                                             options={{renderInnerHtml: true}}/></b></p>
                                            { this.state.productId !== null ?
                                                <div className="gray-dark-text">
                                                <SelectorLesson value={this.state.lessonId} data={this.state}
                                                                updateParent={this.callStudentAnalysis()}/>
                                                    </div>: null }
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col sm={{size: 12}} lg={{size: 6, offset: 0}} md={{size: 4, offset: 0}}>
                            <Card className="card-darker-transparency">
                                <CardHeader>
                                    <h4 className="white-text">
                                        <Translate id="report-student-average.lesson-score"
                                                   options={{renderInnerHtml: false}}/>
                                    </h4>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                            { this.state.studentId !== null
                                            && this.state.productId !== null
                                            && this.state.lessonId !== null
                                            && this.state.passedTotal !== "0"
                                            && this.state.notPassedTotal !== "0"
                                                ?
                                                <ChartAverage data={this.state} refresh={this.state}/> : null }
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}}>
                            <Card className="card-blue-transparency">
                                <CardHeader>
                                    <h4 className="white-text">
                                        <Translate id="report-student-average.average-lesson"
                                                   options={{renderInnerHtml: false}}/>
                                    </h4>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col sm={{size: 12}} lg={{size: 12}}>
                                            <p><b><Translate id="report-student-average.select-exam"
                                                             options={{renderInnerHtml: true}}/></b></p>
                                            { this.state.lessonId !== null
                                            && this.state.productId !== null
                                            && this.state.studentId !== null
                                                ?
                                                <div className="gray-dark-text">
                                                    <SelectorExam value={this.state.examId} refresh={this.state}
                                                                  data={this.state}
                                                                  updateParent={this.callTries()}/>
                                                </div>: null }
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}}>
                            <Card className="card-blue-transparency">
                                <CardHeader>
                                    <h2 className="white-text">
                                        <Translate id="report-student-average.average-lesson"
                                                   options={{renderInnerHtml: false}}/>
                                    </h2>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                            { this.state.examId !== "0"
                                            && this.state.productId !== null
                                            && this.state.lessonId !== null
                                            && this.state.studentId !== null
                                            && this.state.triesChartData != null
                                            && this.state.triesChartData.labels.length > 0 ?
                                                <ChartLessonTries data={this.state} refresh={this.state}/> : null }
                                        </Col>
                                        <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                            {
                                                this.state.examId !== "0"
                                                && this.state.productId !== null
                                                && this.state.lessonId !== null
                                                && this.state.studentId !== null
                                                && this.state.triesChartData !== null
                                                && this.state.triesChartData.labels.length === 0 ?
                                                    <Alert color="danger">
                                                        <Translate id="report-student-average.pending"
                                                                   options={{renderInnerHtml: false}}/>
                                                    </Alert> : null}
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}}>
                            <Card className="card-darker-transparency">
                                <CardHeader>
                                    <h2 className="white-text">
                                        <Translate id="report-student-average.tries"
                                                   options={{renderInnerHtml: false}}/>
                                    </h2>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                            { this.state.examId !== "0"
                                            && this.state.productId !== null
                                            && this.state.lessonId !== null
                                            && this.state.studentId !== null
                                            && this.state.triesData !== null && this.state.triesData.length > 0 ?
                                                <TableTotalTries data={this.state.triesData}
                                                                 refresh={this.state.triesData}/> : null }
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    </Container>
                </div>
                <Footer/>

            </div>
        )
    };
}

export default withLocalize(ReportStudentLessonAverage);